import { useState } from 'react';
import { Box } from 'components/common';
import { FileChartText, FileKind, PDF_MIME_TYPE } from './constants';
import './file.chart.scss';
import { getFileKind } from './helper';

export interface FileViewerProps {
  fileUrl?: string;
  fileTitle: string;
}

export const OpenInNewTabLink = ({ fileUrl }: { fileUrl: string }) => (
  <a href={fileUrl} target="_blank" rel="noopener noreferrer">
    {FileChartText.OPEN_IN_NEW_TAB}
  </a>
);
OpenInNewTabLink.displayName = 'OpenInNewTabLink';

const FileViewer = (props: FileViewerProps) => {
  const { fileUrl, fileTitle } = props;
  const [hasLoadError, setHasLoadError] = useState(false);
  const fileKind = getFileKind(fileUrl);

  if (!fileUrl) {
    return (
      <Box my className="file-chart__message">
        <p>{FileChartText.MISSING_URL}</p>
      </Box>
    );
  }

  if (fileKind === FileKind.UNSUPPORTED) {
    return (
      <Box my className="file-chart__message">
        <p>{FileChartText.UNSUPPORTED}</p>
        <OpenInNewTabLink fileUrl={fileUrl} />
      </Box>
    );
  }

  if (hasLoadError) {
    return (
      <Box my className="file-chart__message">
        <p>{FileChartText.LOAD_ERROR}</p>
        <OpenInNewTabLink fileUrl={fileUrl} />
      </Box>
    );
  }

  if (fileKind === FileKind.PDF) {
    return (
      <div className="file-chart__viewer">
        <object data={fileUrl} type={PDF_MIME_TYPE} aria-label={fileTitle} className="file-chart__pdf">
          <Box my className="file-chart__message">
            <p>{FileChartText.LOAD_ERROR}</p>
            <OpenInNewTabLink fileUrl={fileUrl} />
          </Box>
        </object>
      </div>
    );
  }

  return (
    <div className="file-chart__viewer">
      <img src={fileUrl} alt={fileTitle} className="file-chart__image" onError={() => setHasLoadError(true)} />
    </div>
  );
};

FileViewer.displayName = 'FileViewer';
export default FileViewer;
